import {useEffect, useRef} from 'react';
import {useUnit} from 'effector-react';
import {Toast} from 'primereact/toast';
import {$notification} from '../../models/infoModel/index.js';

export default function Notification() {
    const toast = useRef(null)
    const notification = useUnit($notification)

    const show = (severity, summary, detail) => {
        toast.current.show({severity, summary, detail, sticky: true})
    }

    useEffect(() => {
        if (notification.severity !== null && toast.current !== null) {
            show(notification.severity, notification.summary, notification.detail)
        } else if (toast.current !== null) {
            toast.current.clear()
        }
    }, [notification, toast])

    return notification && <Toast ref={toast} />
}